import { FeeDetails } from "@modules/+new/payments/shared-payments/entities/fee.model";
import { Limits } from "@modules/+new/payments/shared-payments/entities/limits.model";
import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { FiatProviderDetails } from "@modules/+new/payments/features/payment-options/domain/entities/fiat-provider-details.model";
import { Fiat } from "@modules/+new/assets/domain/entities/fiat.model";

export interface SelectAmountAssetData {
	id: number;
	name: string;
	logo: string;
	feeDetails: FeeDetails;
	precision: number;
	symbol: string;
}

export interface SelectAmountStaticData {
	headerKey: string;
	subHeaderKey: string;
}

export interface SelectAmountOutputData {
	amount: number;
	includingFees: boolean;
}

export interface SelectAmountData {
	asset: Fiat;
	fiatDetails: FiatProviderDetails;
	limits: Limits;
	amount: number;
	includingFees: boolean;
}

export interface SelectAmountViewData {
	asset: SelectAmountAssetData;
	limits: Limits;
	amount: number;
	includingFees: boolean;
}

export class SelectAmountViewDataAdapter extends BaseAdapter<SelectAmountData, SelectAmountViewData> {
	public adapt(data: SelectAmountData): SelectAmountViewData | null {
		if (!data) {
			return null;
		}

		return {
			asset: {
				id: data.asset?.id,
				name: data.asset?.name,
				logo: data.asset?.logo?.defaultUrl,
				feeDetails: { ...data.fiatDetails?.feeDetails },
				precision: data.asset?.precision,
				symbol: data.asset?.symbol
			},
			limits: data.limits,
			amount: data.amount,
			includingFees: data.includingFees
		};
	}
}
